export default "__VITE_ASSET__zw73aVbT__"